import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import OwnerDashboard from './dashboard/OwnerDashboard';
import GCDashboard from './dashboard/GCDashboard';
import SubContractorDashboard from './dashboard/SubContractorDashboard';

function Dashboard({ user, isAuthenticated, paymentSripe }) {
    const navigate = useNavigate();
    
    const userRole = useSelector((state) => {
        return state?.userProfileSlice?.userData?.data?.role;
    });

    useEffect(() => {
        if (!isAuthenticated) {
            navigate('/signin');
        }
        if (paymentSripe === "") {
            navigate('/payment');
        }
    }, [user, isAuthenticated, paymentSripe, navigate]);

    // Render role-specific dashboard
    switch (userRole) {
        case 'owner':
            return <OwnerDashboard />;
        case 'general_contractor':
            return <GCDashboard />;
        case 'sub_contractor':
            return <SubContractorDashboard />;
        default:
            // Fallback while loading user data
            return <OwnerDashboard />;
    }
}

export default Dashboard;
